/*
 * Data da entrega
 */

//const moment = require('moment');

const moment = function(d) {
	var data = d || new Date();

	return {
		format: function(formato) {
			if (formato == "H") {
				return data.getHours();
			} else {
				data.setHours(15);
				var year = data.getFullYear();
				var mes = data.getMonth() + 1;
				var dia = data.getDate();

				if (mes < 10) mes = "0" + mes;
				if (dia < 10) dia = "0" + dia;

				return `${year}-${mes}-${dia}`;
			}
		}
	};
};

var $datepicker = $("[name=data_entrega].datepicker-carrinho");
if ($datepicker.length != 0) {
	var entrega = $datepicker.data("entrega");

	var callback = function(resp) {
		var feriados = [];

		if (resp.data) {
			feriados = resp.data.feriados;
		}

		var datas = feriados.map(function(feriado) {
			return feriado.data;
		});

		var isWeekend = function(date) {
			var week = date.getDay();
			if (-1 != [0, 6].indexOf(week)) {
				return true;
			}
			return false;
		};

		var isHollyday = function(date) {
			var data = moment(date).format("YYYY-MM-DD");
			if (-1 != datas.indexOf(data)) {
				return true;
			}
			return false;
		};

		var isUtilDay = function(date) {
			return !isWeekend(date) && !isHollyday(date);
		};

		var minDate = new Date();

		minDate.setHours(15);

		var diasUteis = 0;

		var minimo_dias = entrega.dias_uteis | 0 || 2;
		var hora_limite = entrega.hora_limite | 0 || 18;

		if (moment().format("H") >= hora_limite) {
			minimo_dias++;
		}

		do {
			minDate.setDate(minDate.getDate() + 1);
			if (isUtilDay(minDate)) {
				diasUteis++;
			}
		} while (diasUteis < minimo_dias);

		console.log(diasUteis, minDate);

		$datepicker.datepicker({
			minDate: minDate,
			beforeShowDay: function(date) {
				var selectable = true;
				var tooltip = "";
				if (isWeekend(date)) {
					selectable = false;
				} else if (isHollyday(date)) {
					selectable = false;
					var data = moment(date).format("YYYY-MM-DD");
					var feriado = feriados.filter(function(feriado) {
						return feriado.data == data;
					});
					tooltip = feriado.titulo;
				}

				return [selectable, "", tooltip];
			}
		});
	};

	$.ajax({
		url: "api/index.php",
		type: "post",
		dataType: "json",
		data: {
			query: `
				{
					feriados {
						data
						titulo
					}
				}
			`
		},
		success: callback,
		error: function() {
			callback({
				success: false,
				msg: "Não foi possível carregar os feriados."
			});
		}
	});
}

/*
 * forma de entrega
 */

const Cart = require("./models/cart");

var subtotal = $("[name=total]").data("subtotal") * 1.0;
var frete = $("[name=total]").data("frete") * 1.0;
var desconto = $("[name=desconto]").data("desconto") * 1.0;

Cart.set({
	subtotal: subtotal,
	frete: frete,
	desconto: desconto
});

const Backbone = require("backbone");

var atualizaFrete = function() {
	var $forma_entrega = $("[name=forma_entrega]");
	var $endereco_id = $("[name=endereco_id]");
	var $preco = $(".delivery-price");
	var $frete = $("[name=frete]");

	var valor = 0.0;

	if ($forma_entrega.val() == "Motoboy") {
		var endereco_id = $endereco_id.val() | 0;
		if (0 == endereco_id) {
			$preco.html("-");
		} else {
			valor = $endereco_id.find("option:selected").data("valor") * 1.0;
			$preco.html("R$" + valor.number_format(2, ",", "."));
		}
	} else if ($forma_entrega.val() == "Retirada na loja") {
		$preco.html("Grátis");
	} else {
		$preco.html("-");
	}

	Cart.set("frete", valor);

	$frete.val($preco.html());
};

$("body").on("change", "[name=forma_entrega]", function() {
	var $self = $(this);
	var $form = $self.closest("form");
	var $endereco_id = $form.find("[name=endereco_id]");
	var $div = $endereco_id.closest("div");
	var $a = $div.find("a");

	if ($self.val() == "Motoboy") {
		$endereco_id.prop("disabled", false);
		$endereco_id
			.find("option:not([data-atendido=0])")
			.prop("disabled", false);
		$a.show();
	} else {
		$endereco_id.val("");
		$endereco_id.prop("disabled", "disabled");
		$endereco_id.find("option").prop("disabled", "disabled");
		$a.hide();
	}

	atualizaFrete();

	$endereco_id.trigger("change");
});

$("[name=forma_entrega]").trigger("change");

/*
 * local de entrega
 */

$("body").on("change", "[name=endereco_id]", function() {
	var $self = $(this);
	atualizaFrete();
});

/*
 * novo endereço
 */

$("body").on("submit", "[name=formNovoEndereco]", function() {
	try {
		var $self = $(this);

		if ($self.data("enviando")) return false;
		if (!$self.find(".required").validate()) return false;

		$self.data("enviando", true);
		$.fancybox.showLoading();

		var callback = function(resp) {
			if (undefined != resp.redirect_url) {
				location.href = resp.redirect_url;
				return;
			}

			$self.data("enviando", false);
			$.fancybox.hideLoading();

			if (undefined != resp.popup_url) {
				$.fancybox.open(
					[
						{
							href: resp.popup_url,
							type: "ajax"
						}
					],
					{}
				);
				return;
			}

			if (resp.success) {
				$.fancybox.showLoading();
				location.reload(true);
			} else {
				alert(resp.msg);
			}
		};

		$.ajax({
			url: $self.attr("action"),
			type: "post",
			dataType: "json",
			data: $self.serializeArray(),
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível enviar o formulário."
				});
			}
		});
	} catch (e) {
		console.log(e);
	}

	return false;
});

require("./desconto");

$("body").on("keyup", "[name=numero_cartao]", function() {
	var $self = $(this);
	var numero_cartao = $self.val().replace(/\D/gim, "");

	var bandeira = numero_cartao.cardType();

	var $form = $self.closest("form");
	$form.find("[name=bandeira]").val(bandeira);
});

$("body").on("blur", "[name=numero_cartao]", function() {
	var $self = $(this);
	$self.trigger("keyup");
});

$("body").on("click", ".btn-finalizar-compra", function() {
	var $self = $(this);
	var $form = $self.closest("form");
	$form.trigger("submit");
});

$("body").on("submit", "[name=formPagamento]", function() {
	try {
		var $self = $(this);

		if ($self.data("enviando")) return false;

		var $forma_entrega = jQuery("[name=forma_entrega]");
		var $endereco_id = jQuery("[name=endereco_id]");
		var $data_entrega = jQuery("[name=data_entrega]");
		var $horarioentrega_id = jQuery("[name=horarioentrega_id]");

		var $forma_pagamento = jQuery("[name=forma_pagamento]:checked");
		var $forma_pagamento_retirada = jQuery(
			"[name=forma_pagamento_retirada]"
		);

		var $li = $forma_pagamento.closest("li");

		var $numero_cartao = $li.find("[name=numero_cartao]");
		var $bandeira = $li.find("[name=bandeira]");
		var $installments = $li.find("[name=installments]");
		var $nome_titular = $li.find("[name=nome_titular]");
		var $data_expiracao = $li.find("[name=data_expiracao]");
		var $cvv = $li.find("[name=cvv]");

		var forma_pagamento = $forma_pagamento.val();
		var forma_pagamento_retirada = $forma_pagamento_retirada.val();
		var forma_entrega = $forma_entrega.val();
		var endereco_id = $endereco_id.val() | 0;
		var data_entrega = $data_entrega.val();
		var horarioentrega_id = $horarioentrega_id.val() | 0;

		var numero_cartao = $numero_cartao.val();
		var bandeira = $bandeira.val();
		var installments = $installments.val() | 0;
		var nome_titular = $nome_titular.val();
		var data_expiracao = $data_expiracao.val();
		var cvv = $cvv.val();

		if ("" == forma_entrega) {
			alert("Selecione a forma de entrega.");
			$forma_entrega.focus();
			return false;
		} else if (forma_entrega == "Motoboy" && endereco_id == 0) {
			alert("Selecione o local de entrega.");
			$endereco_id.focus();
			return false;
		} else if (forma_entrega == "Retirada na loja") {
			endereco_id = 0;
		}

		if ("" == data_entrega) {
			alert("Informe a data de entrega.");
			$data_entrega.focus();
			return false;
		}

		if (0 == horarioentrega_id) {
			alert("Selecione o Período.");
			$horarioentrega_id.focus();
			return false;
		}

		if ("" == $forma_pagamento.val()) {
			alert("Selecione a forma de pagamento.");
			return false;
		}

		if (
			"Cartão de Crédito" == $forma_pagamento.val() ||
			"Cartão de Débito" == $forma_pagamento.val()
		) {
			if ("" == numero_cartao) {
				alert("Informe o número do cartão.");
				console.log(numero_cartao, $numero_cartao);
				$numero_cartao.focus();
				return false;
			}
			numero_cartao = numero_cartao.replace(/\D/gim, "");

			if (12 > numero_cartao.length) {
				alert("Informe o número do cartão corretamente.");
				$numero_cartao.focus();
				return false;
			}

			if ("" == bandeira) {
				alert("Selecione a bandeira.");
				$bandeira.focus();
				return false;
			}

			if (
				0 == installments &&
				"Cartão de Crédito" == $forma_pagamento.val()
			) {
				alert("Selecione a quantidade de parcelas.");
				$installments.focus();
				return false;
			}

			if ("" == nome_titular) {
				alert("Informe o nome do titular.");
				$nome_titular.focus();
				return false;
			}

			if (!/([^\s]+\s[^\s]+)+/gim.test(nome_titular)) {
				alert("Informe o nome do titular como escrito no cartão.");
				$nome_titular.focus();
				return false;
			}

			if ("" == data_expiracao) {
				alert("Informe a data de expiração.");
				$data_expiracao.focus();
				return false;
			}

			if (!/^\d{2}\/\d{4}$/gim.test(data_expiracao)) {
				alert("Informe a data de expiração no formata MM/AAAA");
				$data_expiracao.focus();
				return false;
			}

			if ("" == cvv) {
				alert("Informe o CVV.");
				$cvv.focus();
				return false;
			}

			cvv = cvv.replace(/\D/gim, "");
			if (3 > cvv.length) {
				alert("Informe o CVV corretamente.");
				$cvv.focus();
				return false;
			}
		}

		var callback = function(resp) {
			if (null == resp) {
				resp = {
					success: false,
					msg: "Não foi possível enviar o formulário."
				};
			}
			if (undefined != resp.redirect_url) {
				location.href = resp.redirect_url;
				return;
			}

			jQuery.fancybox.hideLoading();
			$self.data("enviando", false);

			if (undefined != resp.popup_url) {
				jQuery.fancybox.open(
					[
						{
							href: resp.popup_url,
							type: "ajax"
						}
					],
					{}
				);
				return;
			}

			alert(resp.msg);

			if (resp.success) {
				jQuery.fancybox.showLoading();
				$self.data("enviando", true);
				location.href =
					$("base").attr("href") + "pedidos/status/" + resp.reference;
				return;
			} else {
				$numero_cartao.val("");
				$bandeira.val("");
				$nome_titular.val("");
				$data_expiracao.val("");
				$cvv.val("");
			}
		};

		jQuery.fancybox.showLoading();
		$self.data("enviando", true);
		$.ajax({
			url: "carrinho/checkout",
			type: "post",
			dataType: "json",
			data: {
				forma_entrega: forma_entrega,
				endereco_id: endereco_id,
				data_entrega: data_entrega,
				horarioentrega_id: horarioentrega_id,
				forma_pagamento: forma_pagamento,
				forma_pagamento_retirada: forma_pagamento_retirada,
				numero_cartao: numero_cartao,
				bandeira: bandeira,
				nome_titular: nome_titular,
				data_expiracao: data_expiracao,
				cvv: cvv
			},
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível enviar o formulário."
				});
			}
		});
	} catch (e) {
		console.log(e);
	}
	return false;
});



//////////////////
// WEBPACK FOOTER
// ../src/carrinho/finalizar.js
// module id = 65
// module chunks = 0